// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import copyFeatureAndTestCaseMng from './metaData/copyFeatureAndTestForm'
export default {
  state: copyFeatureAndTestCaseMng,
  actions
}
